import { CSSProperties, useRef, useState } from 'react';

import ReactImageGallery, { ReactImageGalleryItem } from "react-image-gallery";
import './Start.css';
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";

import okablowanie_strukturalne from '../../assets/start/okablowanie-strukturalne.webp';
import routery_kierunkowe_lte from '../../assets/start/routery-kierunkowe-lte.webp';
import sieci_mesh from '../../assets/start/sieci-mesh-new.webp';

import obsluga from '../../assets/start/obsluga.webp';
import sygnalizacja_pozaru from '../../assets/start/sygnalizacja-pozaru.webp';
import zabepieczenie_budowy from '../../assets/start/zabepieczenie-budowy.webp';

import automatyka_budynkowa from '../../assets/start/automatyka-budynkowa.webp';
import cctv from '../../assets/start/cctv.webp';
import oddymianie from '../../assets/start/oddymianie.webp';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import projekty from '../../assets/start/elektro.png';

import { ACCESS_CONTROL, ALARMS, CCTV, FIRE_PROTECTION, INSTALLATIONS, NETWORKS, toGallery } from '../../slides';
import { Contact } from '../Contact/Contact';
import { Content, contentToDom, SERVICES } from '../new/Realizations/Realizations';
import { ServiceTile } from '../new/service-tile/service-tile';


export function ItemRenderer(i: ReactImageGalleryItem & { galleryRef?: React.RefObject<ReactImageGallery>, isFullscreen?: boolean }) {
  const { i18n } = useTranslation();
  const title = (() => {
    if (typeof i.originalTitle === 'string') {
      return i.originalTitle;
    } else {
      return (i.originalTitle as any)[i18n.language as "pl" | "en"];
    }
  })();

  const style = { "--img": "url(" + i.original + ")" } as CSSProperties;
  return <div className={'custom-gallery-item' + (i.originalClass ?? '')} style={style}>
    <div>
      <div>
        <img loading="lazy" src={i.original} alt={i18n.t(title)} onClick={() => {
          if (i.galleryRef?.current) {
            if (i.isFullscreen) {
              i.galleryRef?.current?.exitFullScreen();
            } else {
              i.galleryRef?.current?.pause();
              i.galleryRef?.current?.fullScreen()
            }
          }
        }} />
        <div className="slide-text">
          <div>
            <div>{i18n.t(title)}</div>
            {i.description && <NavLink to={i.description}>Zobacz więcej w tej kategorii usług...</NavLink>}
          </div>
        </div>
      </div>
    </div>
  </div>
}

const items: ReactImageGalleryItem[] = [
  {
    original: sieci_mesh,
    originalTitle: "start.slides.mesh_networks.title",
    description: "start.slides.mesh_networks.description"
  },
  {
    original: okablowanie_strukturalne,
    originalTitle: "start.slides.structural_cabling.title",
    description: "start.slides.structural_cabling.description"
  },
  {
    original: routery_kierunkowe_lte,
    originalTitle: "start.slides.lte_router.title",
    description: "start.slides.lte_router.description"
  },
  /************************************ */
  {
    original: sygnalizacja_pozaru,
    originalTitle: "start.slides.fire_signaling.title",
    description: "start.slides.fire_signaling.description"
  },
  {
    original: obsluga,
    originalTitle: "start.slides.production_service.title",
    description: "start.slides.production_service.description"
  },
  {
    original: zabepieczenie_budowy,
    originalTitle: "start.slides.construction_security.title",
    description: "start.slides.construction_security.description"
  },
  /************************************ */
  {
    original: automatyka_budynkowa,
    originalTitle: "start.slides.building_automation.title",
    description: "start.slides.building_automation.description"
  },
  {
    original: cctv,
    originalTitle: "start.slides.cctv.title",
    description: "start.slides.cctv.description"
  },
  {
    original: oddymianie,
    originalTitle: "start.slides.smoke_detection.title",
    description: "start.slides.smoke_detection.description"
  },
  {
    original: projekty,
    originalTitle: "start.slides.projects.title",
    description: "start.slides.projects.description"
  },
]

const newGalleryItems = toGallery([
  { ...INSTALLATIONS[0], path: SERVICES[0].path },
  { ...ALARMS[0], path: SERVICES[1].path },
  { ...CCTV[0], path: SERVICES[2].path },
  { ...ACCESS_CONTROL[0], path: SERVICES[3].path },
  { ...FIRE_PROTECTION[0], path: SERVICES[4].path },
  { ...NETWORKS[0], path: SERVICES[5].path }
]);

export function Start() {
  const { i18n } = useTranslation();
  const galleryRef = useRef<ReactImageGallery>(null);
  const [fullscreen, setFullscreen] = useState(false);

  return <div className="Start">
    <div className='banner'>
      <div className='banner-text'>
        <span className='title'>{i18n.t("start.banner.title")} </span>
        <span className='subtitle'>{i18n.t("start.banner.subtitle")}</span>
      </div>
      <nav className='banner-buttons'>
        <NavLink to="/#contact">{i18n.t("start.banner.estimate")}</NavLink>
        <NavLink to="/#realizations">{i18n.t("start.banner.realizations")}</NavLink>
      </nav>
      {/* <NavLink to={'/configurator'}><button className='orange large'>{i18n.t("start.banner.button")}</button></NavLink> */}
    </div>
    <div className='content'>
      <section id="services">
        <div className='section-title'>{i18n.t("menu.services")}</div>
        <nav className='service-tiles'>
          {SERVICES.map((tile, i) => (
            <NavLink to={tile.path} key={tile.title}><ServiceTile img={tile.img} title={i18n.t(tile.title)} description={tile.description[(i18n.language as "pl" | "en")]} /></NavLink>
          ))}
        </nav>
      </section>
      <section id="about">
        <div className='section-title'>{i18n.t("menu.about")}</div>
        <div className='about-content'>
          { contentToDom(i18n.t("about.content", { returnObjects: true }) as Content[]) }
        </div>
      </section>
      <section id="realizations">
        <div className='section-title'>{i18n.t("menu.realizations")}</div>
        <ReactImageGallery
          ref={galleryRef}
          onScreenChange={setFullscreen}
          items={newGalleryItems}
          infinite={true}
          showNav={true}
          showFullscreenButton={fullscreen}
          showPlayButton={true}
          showBullets={true}
          autoPlay={true}
          renderItem={(p) => <ItemRenderer galleryRef={galleryRef} isFullscreen={fullscreen} {...p}></ItemRenderer>}
          additionalClass='custom-gallery'
        />
      </section>
      <section id="contact">
        <div className='section-title'>{i18n.t("menu.contact")}</div>
        <Contact></Contact>
      </section>
      {/* <div className='slide-text'>
        <div className="spacing-bottom">
          {i18n.t("about.text")}
        </div>
        <div>
          {i18n.t("start.cards.competencies.text")}
          <ul>
            <li>{i18n.t("certificates.slides.dh.title")} - {i18n.t("certificates.slides.dh.description")}</li>
            <li>{i18n.t("certificates.slides.fibaro.title")} - {i18n.t("certificates.slides.fibaro.description")}</li>
            <li>{i18n.t("certificates.slides.fiber.title")} - {i18n.t("certificates.slides.fiber.description")}</li>
            <li>{i18n.t("certificates.slides.grenton2.title")} - {i18n.t("certificates.slides.grenton2.description")}</li>
            <li>{i18n.t("certificates.slides.mikrotik.title")} - {i18n.t("certificates.slides.mikrotik.description")}</li>
            <li>{i18n.t("certificates.slides.roger.title")} - {i18n.t("certificates.slides.roger.description")}</li>
            <li>{i18n.t("certificates.slides.dahua.title")} - {i18n.t("certificates.slides.dahua.description")}</li>
            <li>{i18n.t("certificates.slides.sep.title")} - {i18n.t("certificates.slides.sep.description")}</li>
          </ul>
        </div>
      </div> */}
      {/* <div className='card'>
        <Title text={i18n.t("start.cards.about.title") + " TSN sp. z o.o."}></Title>
        <div className='slide-text'>
          {i18n.t("start.cards.about.text")}
        </div>
      </div>

      <div className='row'>
        <div className='card'>
          <Title text={i18n.t("start.cards.competencies.title")}></Title>
          <div className='slide-text'>
            {i18n.t("start.cards.competencies.text")}
            <ul>
              <li>{i18n.t("certificates.slides.dh.title")} - {i18n.t("certificates.slides.dh.description")}</li>
              <li>{i18n.t("certificates.slides.fibaro.title")} - {i18n.t("certificates.slides.fibaro.description")}</li>
              <li>{i18n.t("certificates.slides.fiber.title")} - {i18n.t("certificates.slides.fiber.description")}</li>
              <li>{i18n.t("certificates.slides.grenton2.title")} - {i18n.t("certificates.slides.grenton2.description")}</li>
              <li>{i18n.t("certificates.slides.mikrotik.title")} - {i18n.t("certificates.slides.mikrotik.description")}</li>
              <li>{i18n.t("certificates.slides.roger.title")} - {i18n.t("certificates.slides.roger.description")}</li>
              <li>{i18n.t("certificates.slides.dahua.title")} - {i18n.t("certificates.slides.dahua.description")}</li>
              <li>{i18n.t("certificates.slides.sep.title")} - {i18n.t("certificates.slides.sep.description")}</li>
            </ul>
          </div>
        </div>
        <div className='card'>
          <Title text={i18n.t("start.cards.experience.title")}></Title>
          <div className='slide-text'>
            {i18n.t("start.cards.experience.text")}
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='card'>
          <Title text="Text 3"></Title>
        </div>
        <div className='card'>
          <Title text="Text 4"></Title>
        </div>
      </div>

      <div className='row'>
        <div className='card'>
          <Title text="Text 5"></Title>
        </div>
        <div className='card'>
          <Title text="Text 6"></Title>
        </div> 
      </div>*/}
    </div>
  </div>
  //     </div><ImageGallery
  //   items={items}
  //   infinite={true}
  //   showNav={false}
  //   showFullscreenButton={false}
  //   showPlayButton={false}
  //   showBullets={true}
  //   autoPlay={true}
  //   renderItem={(p) => <MemoItemRenderer {...p}></MemoItemRenderer>}
  //   additionalClass='custom-gallery'
  // />
}
